/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
const awsmobile = {
  aws_project_region: "ap-northeast-2",

  Auth: {
    region: "ap-northeast-2",
    userPoolId: "ap-northeast-2_bjCkJC9Lj", // Please change this value.
    userPoolWebClientId: "4k1ir4lijkt6jvn31og2pn7ug0", // Please change this value.
    identityPoolId: "ap-northeast-2:8dd47ed0-67fc-4bbc-91e4-9005519e40b0", // Please change this value.
  },
  Storage: {
    AWSS3: {
      bucket: "ezwelliveprod-channelbackendstack-wa-ap-northeast-2-05182",
      region: "ap-northeast-2",
    },
  },
  aws_cloud_logic_custom: [
    {
      name: "MainApi",
      endpoint: "https://aclf2z36g1.execute-api.ap-northeast-2.amazonaws.com/Prod",
      region: "ap-northeast-2",
    },
    {
      name: "UnAuth",
      endpoint: "https://aclf2z36g1.execute-api.ap-northeast-2.amazonaws.com/Prod",
      region: "ap-northeast-2",
    },
    {
      name: "ChannelApi",
      endpoint: "https://ezwel-api.livehyundai.com/channel",
      region: "ap-northeast-2",
    },
    {
      name: "AdminIotApiName",
      endpoint: "https://m3akzzlrvj.execute-api.ap-northeast-2.amazonaws.com/Prod",
      region: "ap-northeast-2",
    },
    {
      name: "Statistic",
      endpoint: "https://ezwel-api.livehyundai.com/client/",
      region: "ap-northeast-2",
    },
  ],
};

export default awsmobile;
